export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <h3 className="text-4xl font-bold mb-4" style={{ fontFamily: "'Pacifico', serif" }}>
              APEX
            </h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              A selective book promotion service connecting exceptional authors with over 300 highly engaged book clubs. Founded by professional book promoter Katya McGregor.
            </p>
          </div>
          
          <div>
            <h4 className="text-xl font-bold mb-4 text-amber-400">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#how-it-works" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#request-slot" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  Request a Slot
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  Success Stories
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  About Katya
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-xl font-bold mb-4 text-amber-400">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-amber-400 text-xl mt-1"></i>
                <div>
                  <div className="text-gray-400">Email</div>
                  <a href="mailto:kateyamcgregor@gmail.com" className="text-white hover:text-amber-400 transition-colors cursor-pointer">
                    kateyamcgregor@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-amber-400 text-xl mt-1"></i>
                <div>
                  <div className="text-gray-400">Response Time</div>
                  <div className="text-white">Within 3-5 business days</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} APEX Book Promotion. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="nofollow noopener noreferrer" 
                className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
